var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-action" }, [
    _c("h6", { staticClass: "event-action__title" }, [
      _vm._v("Стоимость участия:")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "event-action__prices" }, [
      _c("span", {
        staticClass: "event-action__price",
        domProps: { innerHTML: _vm._s(_vm.prices.current) }
      }),
      _vm._v(" "),
      _vm.prices.old
        ? _c("span", {
            staticClass: "event-action__price-old",
            domProps: { innerHTML: _vm._s(_vm.prices.old) }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "event-action__btn",
        class: { "event-action__btn--active": _vm.productInCart }
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-main btn-block",
            attrs: { disabled: _vm.isLoading || _vm.productInCart },
            on: { click: _vm.addToBasket }
          },
          [
            _vm.isLoading
              ? _c("span", { staticClass: "spinner-border spinner-border-sm" })
              : _c(
                  "span",
                  [
                    _vm.productInCart
                      ? [_vm._v("Добавлено в корзину")]
                      : [_vm._v(" В корзину")]
                  ],
                  2
                )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "event-action__error" }, [
          _vm._v("\n        " + _vm._s(_vm.error) + "\n    ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }